export const REGISTER_URL = 'https://evalentx.com/events/00c2eccd-df04-434d-bfd4-54f9c0f399d5';
export const VENUE = 'SRM Institute of Science and Technology';
export const ADDRESS = 'SRM Nagar, Kattankulathur – 603 203, Chengalpattu District, Tamil Nadu, India.';
export const FULL_ADDRESS = `${VENUE}, ${ADDRESS}`;
export const PARTNER = 'AARUUSH';
export const EVENT_START = new Date('2026-11-16T09:00:00+05:30');
export const HACK_START = new Date('2026-11-16T13:00:00+05:30');
export const HACK_END = new Date('2026-11-17T13:00:00+05:30');
export const EVENT_END = new Date('2026-11-17T19:00:00+05:30');

export const NAV = [
  ['Overview', 'overview'], ['Workshop', 'workshop'], ['Themes', 'themes'],
  ['Timeline', 'timeline'], ['HR Conclave', 'hr-conclave'], ['Prizes', 'prizes'],
];

export const COUPON_USES = ['AI-powered mock interviews', 'ATS-friendly resume creation', 'Job application services or features', 'Freelance project bidding'];

export const SYLLABUS = [
  { n: '01', title: 'AI & LLM Fundamentals', mins: 30, points: ['Generative AI and large language models.', 'Tokens, prompts, context windows, and model limitations.', 'Prompt engineering and structured outputs.'] },
  { n: '02', title: 'Introduction to AI Agents', mins: 35, points: ['AI assistants versus autonomous agents.', 'The agent loop: observe, reason, act, and evaluate.', 'Tools, APIs, memory, and task planning.'] },
  { n: '03', title: 'Building an Agentic Workflow', mins: 45, points: ['Designing a task-specific agent.', 'Tool calling and API integration concepts.', 'Connecting models with external tools or data.', 'Human approval and safety guardrails.'] },
  { n: '04', title: 'Hands-on Mini Project', mins: 50, points: ['Build or configure a basic AI workflow.', 'Explore a research, recruitment, or task-automation assistant.', 'Test sample inputs and examine outputs.'] },
  { n: '05', title: 'Deployment Concepts & Q&A', mins: 20, points: ['Deployment and monitoring fundamentals.', 'Privacy, reliability, responsible AI, and evaluation.', 'Hackathon project ideas and Q&A.'] },
];

export const THEMES = [
  { n: '01', title: 'Agentic AI & Autonomous Enterprise', blurb: 'Build AI-powered systems that plan, reason, use tools, and execute multi-step tasks to solve real business and societal challenges.',
    areas: ['AI agents for enterprise workflow automation.', 'AI-powered recruitment and workforce intelligence.', 'Multi-agent systems for education and healthcare.', 'Secure and auditable AI automation.', 'AI-native productivity applications.'] },
  { n: '02', title: 'DeepTech, Smart Infrastructure & Sustainable Innovation', blurb: 'Develop practical, scalable technology solutions through AI, robotics, cybersecurity, IoT, climate technology, and intelligent infrastructure.',
    areas: ['Smart mobility, EV infrastructure, and energy optimisation.', 'Robotics and AI for manufacturing and logistics.', 'Climate technology and resource management.', 'Cybersecurity and digital trust.', 'Technology for agriculture, healthcare, and education.'] },
];

export const ROUNDS = [
  { n: '01', title: 'Ideation & Initial Development', when: '16 November', tag: 'Non-elimination',
    text: 'Teams develop their initial concepts and prototypes. All eligible participating teams continue to Round 2.' },
  { n: '02', title: 'Technical Evaluation', when: '17 November', tag: 'Elimination',
    text: 'Judges evaluate working functionality, technical implementation, innovation, and problem relevance. Selected teams progress to the final round.' },
  { n: '03', title: 'Final Pitch & Jury Evaluation', when: '17 November', tag: 'Final',
    text: "Finalists demonstrate their prototypes, explain their solution's value, and answer jury questions. Final rankings determine the winners." },
];

// [when, activity, kind, duration]; kind 'hack' = inside the 24-hour hackathon window
export const TIMELINE = [
  { day: 'Day 01', date: 'Monday, 16 November', items: [
    ['9:00 AM', 'Registration & Check-in', null, '30 min'],
    ['9:30 AM', 'AI & Agentic AI Workshop', 'workshop', '3 hrs'],
    ['12:30 PM', 'Break', null, '30 min'],
    ['1:00 PM', 'Hackathon Kick-off', 'hack', null],
    ['Through the night', 'Hackathon Development', 'hack', null],
  ] },
  { day: 'Day 02', date: 'Tuesday, 17 November', items: [
    ['1:00 PM', 'Hackathon Concludes', 'hack', null],
    ['1:00 – 2:00 PM', 'Break', null, '1 hr'],
    ['2:00 – 4:00 PM', 'Awards & Prize Distribution Ceremony', null, '2 hrs'],
    ['4:00 – 7:00 PM', 'CONVERGE HR Conclave', 'hr', '3 hrs'],
    ['From 7:00 PM', 'Closing & Departure', null, null],
  ] },
];

export const CONCLAVE_AUDIENCE = ['HR leaders and CHROs', 'Talent acquisition professionals', 'Industry speakers', 'Training & Placement Officers', 'University representatives', 'Students and emerging professionals', 'Startup founders and technology leaders'];
export const CONCLAVE_TOPICS = ['AI and automation in the workplace', 'Future skills and changing hiring requirements', 'Skills-based hiring and technology-enabled recruitment', 'Industry–academia collaboration', 'Employability and campus placements', 'Building future-ready teams'];

export const WHY = [
  ['Learn', 'Explore AI and Agentic AI in a focused workshop.'],
  ['Build', 'Develop a working prototype around real-world problems.'],
  ['Compete', 'Progress through three evaluation rounds and compete for prizes.'],
  ['Connect', 'Engage with fellow builders and industry professionals.'],
  ['Pitch', 'Present your technical solution and its commercial potential.'],
  ['Level Up', 'Explore eligible career-development services through EvalentX coupons.'],
];
